<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <v-icon v-text="$route.icon"></v-icon>
          {{ $route.name }}
        </v-card-title>
        <v-btn
          fab
          color="primary"
          @click="dialog = true"
          absolute
          bottom
          right
          v-if="admin.boardMember"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-card>
      <v-dialog v-model="dialog" max-width="650px">
        <v-form ref="newProject" lazy-validation>
          <v-card class="mx-auto text-start padding-20">
            <v-card-title>Add Project </v-card-title>
            <v-card-text clas="padding-20">
              <v-text-field
                v-model="project.name"
                label="Name"
                :rules="requiredRules.concat(maxCharRules)"
                color="primary"
                maxLength="1000"
                outlined
                counter
              >
              </v-text-field>
              <v-textarea
                required
                v-model="project.description"
                label="Project"
                :rules="requiredRules.concat(maxCharRules)"
                outlined
                color="primary"
                maxLength="1000"
                height="100px"
                counter
              ></v-textarea>
              <v-row>
                <v-col cols="5">
                  <v-text-field
                    v-model="project.budget"
                    type="number"
                    label="Budget"
                    outlined
                    color="primary"
                  ></v-text-field>
                </v-col>
                <v-col cols="7">
                  <v-text-field
                    type="date"
                    v-model="project.completionDate"
                    label="Deadline"
                    outlined
                    color="primary"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-text-field
                v-model="project.projectManager"
                label="Project Manager"
                outlined
                color="primary"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addProject">Submit</v-btn>
              <v-btn
                color="error"
                text
                @click="
                  dialog = false;
                  $refs.newProject.reset();
                "
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { projectsRef } from "../../../firebaseApp";
import projectObject from "../../json/project.json";

export default {
  data: () => ({
    project: projectObject,
    dialog: false,
    requiredRules: [(v) => !!v || "Required"],
    maxCharRules: [(v) => v.length <= 1000 || "Max 25 characters"],
    member: {},
    admin: {},
    error: {
      message: "",
    },
  }),
  methods: {
    loadMemberInfo() {
      this.member = this.$store.state.member;
      this.admin = this.$store.state.admin;
    },
    addProject() {
      if (this.$refs.newProject.validate()) {
        this.project.dateAdded = Date.now();
        this.project.communityCode = this.member.communityCode;
        this.project.memberKey = this.member.id;
        this.project.creator =
          this.member.firstName + " " + this.member.lastName;
        projectsRef.push(this.project).key;
        this.$refs.newProject.reset();
        this.dialog = false;
      }
    },
  },
  mounted() {
    this.loadMemberInfo();
  },
};
</script>